/* eslint-disable react/prop-types */
import Flex from "@/components-library/layout/flex";
import classes from "./contacts.module.scss";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import Grid from "@/components-library/layout/grid";
import classNames from "classnames";
import Label from "@/components-library/widgets/label";
import Form from "./form";
import { LINKS } from "@/static-texts/links";

function Contacts({ content: contacts }) {
  return (
    <Flex
      align="flex-start"
      className={classes.contacts}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={contacts.header.header}
        title={contacts.header.title}
        subTitle={contacts.header.subTitle}
      />

      <Grid columns="1fr 1fr" className={classNames(classes.container)}>
        <Flex
          align="flex-start"
          direction="column"
          justify="center"
          className={classes.left}
        >
          <Flex
            justify="center"
            align="center"
            direction="row"
            className={classes.contactContainer}
          >
            <img
              src={"/images/contacts/PROSSIMITI-Contatti-icon-phone.svg"}
              alt="Logo"
            />
            <Flex
              justify="center"
              align="flex-start"
              direction="column"
              className={classes.content}
            >
              <Label size="md" color="secondary">
                CHIAMACI
              </Label>
              <Label tag="h5" color="secondary" weight="bold">
                +39 353 44 33 037
              </Label>
            </Flex>
          </Flex>

          <Flex
            justify="center"
            align="center"
            direction="row"
            className={classes.contactContainer}
          >
            <img
              src={"/images/contacts/PROSSIMITI-Contatti-icon-whatsapp.svg"}
              alt="Logo"
            />
            <Flex
              justify="center"
              align="flex-start"
              direction="column"
              className={classes.content}
            >
              <Label size="md" color="secondary">
                SCRIVICI SU WHATSAPP
              </Label>
              <Label tag="h5" color="secondary" weight="bold">
                +39 335 75 41 573
              </Label>
            </Flex>
          </Flex>
          <Flex
            justify="center"
            align="center"
            direction="row"
            className={classes.contactContainer}
          >
            <img
              src={"/images/contacts/PROSSIMITI-Contatti-icon-email.svg"}
              alt="Logo"
            />
            <Flex
              justify="center"
              align="flex-start"
              direction="column"
              className={classes.content}
            >
              <Label size="md" color="secondary">
                SCRIVICI VIA EMAIL
              </Label>
              <Label tag="h5" color="secondary" weight="bold">
                info@prossimiti.it
              </Label>
            </Flex>
          </Flex>
          <Flex
            justify="center"
            align="center"
            direction="row"
            className={classes.contactContainer}
          >
            <img
              src={"/images/contacts/PROSSIMITI-Contatti-icon-place.svg"}
              alt="Logo"
            />
            <Flex
              justify="center"
              align="flex-start"
              direction="column"
              className={classes.content}
            >
              <Label size="md" color="secondary">
                VIENI A TROVARCI
              </Label>
              <Label tag="h5" color="secondary" weight="bold" align="start">
                Via Tien An Men 21 Sassuolo (MO)
              </Label>
            </Flex>
          </Flex>
          <Label
            tag="h5"
            color="secondary"
            weight="bold"
            align="start"
            className={classes.footer}
          >
            Non perderti le novità di Prossimiti, seguici sui social per restare
            aggiornato!
          </Label>
          <Flex justify="center" align="flex-start" direction="row">
            <img
              src={"/images/contacts/PROSSIMITI-Contatti-icon-instagram.svg"}
              alt="Logo"
              className={classes.icon}
              onClick={() => window.open(LINKS.INSTAGRAM, "_blank")}
            />
            <img
              src={"/images/contacts/PROSSIMITI-Contatti-icon-facebook.svg"}
              alt="Logo"
              className={classes.icon}
              onClick={() => window.open(LINKS.FACEBOOK, "_blank")}
            />
            <img
              src={"/images/contacts/PROSSIMITI-Contatti-icon-linkedin.svg"}
              alt="Logo"
              className={classes.icon}
              onClick={() => window.open(LINKS.LINKEDIN, "_blank")}
            />
          </Flex>
        </Flex>
        <Form />
      </Grid>
    </Flex>
  );
}

export default Contacts;
